import React, { useEffect } from "react";
import "./index.less";
import { useDispatch, useSelector } from "react-redux";
import {
    updateCommonErrorMessage,
    updateCommonWarnMessage,
    updateCurrentStage,
    updateIsClickedClearButton,
    updateIsClickedSearchButton,
    updateIsClickedSearchResultButton,
    updateIsLoadingForGetSearchResult,
    updateIsResetContentForCurrentTabChange,
    updateIsResetMapContentBeforeSearch,
    updateNeedClearLocation,
    updateNeedClearRegion,
    updateSearchReuslt,
} from "@/redux/actions/weevilTrakAction";
import { WeevilTrakTabsEnum } from "@/util/cosntants";
import { RootState } from "@/redux/reducer/store";
import { weevilTrak } from "@/util/http/WeevilTrak";
import { IGetWeevilTrakReqModel } from "@/util/http/WeevilTrak/requestType";
import { updateSearchStagesData } from "@/redux/actions/weevilTrakAction";
import { fetchWithDailyCache } from "./dailyCache";
import { IGetWeevilTrakResModel } from "@/util/http/WeevilTrak/responseType";


const LightingInvokeButton = () => {

    const dispatch = useDispatch();

    const currentTab = useSelector((state: RootState) => state.weevTrakReducer.currentTab);
    const currentStage = useSelector((state: RootState) => state.weevTrakReducer.currentStage);
    const isResetContentForCurrentTabChange = useSelector((state: RootState) => state.weevTrakReducer.isResetContentForCurrentTabChange);
    const isClickedSearchButton = useSelector((state: RootState) => state.weevTrakReducer.isClickedSearchButton);

    // for location
    const locationNameOrCoordinate = useSelector((state: RootState) => state.weevTrakReducer.locationNameOrCoordinate);
    const radiusValue = useSelector((state: RootState) => state.weevTrakReducer.radiusValue);
    const squareHalfSide = useSelector((state: RootState) => state.weevTrakReducer.squareHalfSide);
    const selectedLocationItem = useSelector((state: RootState) => state.weevTrakReducer.selectedLocationItem);
    // for region
    // TODO: need store all tree checked , expends and other's data to redux
    const checkedKeys = useSelector((state: RootState) => state.weevTrakReducer?.checkedKeys);

    // // Use a local state for debounced radius
    // const [debouncedRadius, setDebouncedRadius] = React.useState(radiusValue);

    // React.useEffect(() => {
    //     const handler = setTimeout(() => {
    //         setDebouncedRadius(radiusValue);
    //     }, 1000); // 1 second debounce time

    //     return () => {
    //         clearTimeout(handler);
    //     };
    // }, [radiusValue]);

    // test
    const searchStagesData = useSelector((state: RootState) => state.weevTrakReducer.searchStagesData);




    const clearDatas =()=>{
        dispatch(updateIsClickedSearchButton(false));
        //For location
        dispatch(updateNeedClearLocation(true));
        //for region
        dispatch(updateNeedClearRegion(true));
        // clear result and stages
        dispatch(updateSearchStagesData(null));
        dispatch(updateCurrentStage(null));

        dispatch(updateIsClickedClearButton(true));
    };

    const isCoordinateFormat = (str: string) => {
        if (!str) return false;
        // Regex allows: optional minus, digits, optional decimal part.
        // Comma separated with optional spaces.
        return /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/.test(str.trim());
    };

    const slefSleep = (ms: number) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    };
    const blockForOneSecond = async () => {
        await slefSleep(1000); // 模拟阻塞1秒
    };


    // for location: when location change, need to clear stage and result

    // for search result
    const publicHandleSearchResult = async() => {
        let tmpFlag = false;
        const searchRequest: IGetWeevilTrakReqModel = {
            // predictionDate: dayjs().format("YYYY-MM-DD"), // default to today, can be updated based on UI input
        };

        let tmpKey = "";
        let tmpMessage = "";
        if(!currentStage || currentStage.length === 0){
            tmpMessage = "Please select one stage.";
        }
        else{
            if (currentTab === WeevilTrakTabsEnum.LOCATION) {

                if(locationNameOrCoordinate && radiusValue >= 0 ) {
                    tmpFlag = true;
                    if(currentStage && currentStage.length > 0){
                    // searchRequest.stage = currentStage?.[0];
                    }

                    if(!isCoordinateFormat(locationNameOrCoordinate)){
                        searchRequest.geometry = {
                            coordinates: [selectedLocationItem?.longitude, selectedLocationItem?.latitude],
                            properties: {
                                radius: radiusValue * 2,
                                squareHalfSide: squareHalfSide
                            },
                            type: "Point"
                        };
                        tmpKey = `${selectedLocationItem?.longitude}#${selectedLocationItem?.latitude}#${radiusValue}`;
                    }
                    else{
                        const coords = locationNameOrCoordinate.split(",").map(coord => parseFloat(coord.trim()));
                        const finalCoords = [coords[1], coords[0]]; // 转换为 [lng, lat] 顺序
                        searchRequest.geometry = {
                            coordinates: finalCoords,
                            properties: {
                                radius: radiusValue * 2,
                                squareHalfSide: squareHalfSide
                            },
                            type: "Point"
                        };
                        tmpKey = `${searchRequest?.geometry?.coordinates?.[0]}#${searchRequest?.geometry?.coordinates?.[1]}#${radiusValue}`;
                    }
                }
                else{
                    tmpMessage = "Please provide a location.";
                }

            } else if (currentTab === WeevilTrakTabsEnum.Region) {
                if(checkedKeys && checkedKeys.length > 0) {
                    tmpFlag = true;
                    const areas = checkedKeys?.map(key => {
                        const parts = key.split("#");
                        return parts[parts.length - 1];
                    });
                    // Remove duplicates using Set
                    const tmpAreas = Array.from(new Set(areas));
                    searchRequest.areas = tmpAreas?.filter(item => item !== "United States" && item !== "Canada");
                    tmpKey = [...searchRequest.areas]
                        .sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" }))
                        .join("#");
                }
                else{
                    tmpMessage = "Please select at least one region.";
                }
                // if(currentStage && currentStage.length > 0){
                // // searchRequest.stage = currentStage?.[0];
                // }
            }

        }


        // operation for add to Favourites
        if (tmpFlag) {
            try{
                dispatch(updateIsResetMapContentBeforeSearch(true));
                dispatch(updateSearchReuslt(null));
                // 等待一个微任务，确保重置逻辑完成
                await Promise.resolve();
                dispatch(updateIsLoadingForGetSearchResult(true));
                console.log("Search Request: ", searchRequest);
                const resData = await fetchWithDailyCache(tmpKey, async () => {
                    const res = await weevilTrak(searchRequest);
                    return res?.data;
                });
                // filter by stage
                const currentStageIndex = Number(currentStage?.replace("Stage", ""));
                const fiterResDataByState:IGetWeevilTrakResModel = {
                    message: resData?.message,
                    totalLocations: resData?.totalLocations,
                    locations: resData?.locations?.map(location => {
                        return {
                            latitude: location.latitude,
                            longitude: location.longitude,
                            predictions: location.predictions?.filter(prediction => prediction?.stageId === currentStageIndex)
                        };
                    }),
                    center: resData?.center,
                };
                // const res = await weevilTrak(searchRequest);
                console.log("weevilTrak aa currentStage: ",currentStage);
                console.log("weevilTrak aa resData: ",resData);
                console.log("weevilTrak aa fiterResDataByState: ",fiterResDataByState);
                await blockForOneSecond(); // 阻塞1秒，模拟等待
                if(fiterResDataByState){
                    dispatch(updateSearchStagesData(fiterResDataByState));
                }
                else{
                    dispatch(updateCommonErrorMessage("Sorry, the current version of the model does not cover the requested location."));
                }

            }
            catch (error) {
                console.error("Error fetching lightning type contours:", error);
                console.error("Error fetching lightning type contours data:", error?.data);
                dispatch(updateCommonErrorMessage("Sorry, the current version of the model does not cover the requested location."));
                // dispatch(updateCommonWarnMessage(publicHandleErrorRequestMessage()));
            }
            finally{
                dispatch(updateIsLoadingForGetSearchResult(false));
                dispatch(updateIsClickedSearchResultButton(true));
            }
        }
        else{
            dispatch(updateCommonWarnMessage(tmpMessage));
        }
    };

    useEffect(()=>{
        if(isResetContentForCurrentTabChange){
            // clear result and stages
            clearDatas();
            dispatch(updateIsResetContentForCurrentTabChange(false));
        }
    },[isResetContentForCurrentTabChange]);


    useEffect(()=>{
        if(!isClickedSearchButton || !currentStage) return;
        // for region
        if(currentTab === WeevilTrakTabsEnum.Region){
            if(checkedKeys && checkedKeys.length > 0) {
                publicHandleSearchResult();
            }
        }
        // for location
        if(currentTab === WeevilTrakTabsEnum.LOCATION){
            if( (locationNameOrCoordinate || selectedLocationItem)){
                publicHandleSearchResult();
            }
        }

    },[currentStage]);


    // console.log("new changege currentStage: ",currentStage);
    // console.log("new changege isClickedSearchButton: ",isClickedSearchButton);
    // console.log("new changege searchStagesData: ",searchStagesData);
    // console.log("new changege locationNameOrCoordinate: ",locationNameOrCoordinate);
    // console.log("new changege selectedLocationItem: ",selectedLocationItem);
    // console.log("new changege radiusValue: ",radiusValue);
    // console.log("======================================================");
    // console.log();

    return (
        <div className="weevilTrak-invoke-button">
            <div className="lighting-invoke-clear-search">
                <div className="weevilTrak-invoke-button-item clear"
                    onClick={()=>{
                        clearDatas();
                    }}>Clear</div>
                <div className="weevilTrak-invoke-button-item search"
                    onClick={()=>{
                        dispatch(updateIsClickedSearchButton(true));
                        publicHandleSearchResult();
                    }}
                >Search Result</div>
            </div>
        </div>
    );
};

export default LightingInvokeButton;